export const translations = {
  it: {
    // nav
    "nav.home": "Home",
    "nav.products": "Prodotti Digitali",
    "nav.smart": "Servizi Smart",
    "nav.categories": "Categorie",
    "nav.career": "Career",
    "nav.business": "Business & Social",
    "nav.hospitality": "Hospitality",
    "nav.oss": "OSS",
    "nav.about": "Chi siamo",
    "nav.faq": "FAQ",
    "nav.contact": "Contatti",
    "nav.cart": "Carrello",
    "nav.account": "Area personale",
    "nav.login": "Accedi",
    "nav.register": "Registrati",
    "nav.logout": "Esci",
    "nav.admin": "Amministrazione",
    // common
    "common.demo": "DEMO",
    "common.comingSoon": "Prossimamente",
    "common.availableNow": "Disponibile ora",
    "common.tryNow": "Provalo ora",
    "common.addToCart": "Aggiungi al carrello",
    "common.buyNow": "Acquista ora",
    "common.viewDetails": "Vedi dettagli",
    "common.from": "da",
    "common.explore": "Scopri",
    "common.loading": "Caricamento...",
    "common.all": "Tutti",
    "common.search": "Cerca prodotti...",
    "common.free": "Gratis",
    "common.download": "Scarica",
    "common.discover": "Scopri i prodotti",
    "common.discoverSmart": "Scopri i Servizi Smart",
    // hero
    "hero.badge": "Strumenti digitali & servizi smart",
    "hero.title": "Strumenti digitali e servizi smart.",
    "hero.titleAccent": "Dal bisogno al risultato pronto.",
    "hero.subtitle": "LearnSphereHub è una piattaforma di prodotti digitali scaricabili e servizi smart personalizzati. Trova lo strumento giusto e ottieni subito il risultato.",
    "hero.cta1": "Esplora i prodotti",
    "hero.cta2": "Servizi Smart",
    // home sections
    "home.categoriesTitle": "Esplora per categoria",
    "home.categoriesSub": "Prodotti organizzati per ambito. OSS è una delle categorie del negozio, non l'intero sito.",
    "home.featuredTitle": "Prodotti in evidenza",
    "home.featuredSub": "Una selezione dei nostri prodotti digitali.",
    "home.howTitle": "Come funziona",
    "home.how1Title": "Scegli il prodotto",
    "home.how1": "Sfoglia il catalogo di prodotti digitali per categoria.",
    "home.how2Title": "Acquista in sicurezza",
    "home.how2": "Checkout rapido con pagamento tramite Stripe.",
    "home.how3Title": "Scarica subito",
    "home.how3": "Trovi i tuoi file nell'area personale, pronti da usare.",
    "home.smartTitle": "Servizi Smart",
    "home.smartSub": "Genera risultati personalizzati direttamente su LearnSphereHub.",
    // smart services
    "smart.title": "Servizi Smart",
    "smart.badge": "Servizi su misura",
    "smart.subtitle": "Servizi personalizzati che trasformano il tuo bisogno in un risultato pronto.",
    "smart.cv.title": "CV Smart",
    "smart.cv.desc": "Genera un curriculum professionale e su misura in pochi minuti.",
    "smart.social.title": "Social & Flyer Creator",
    "smart.social.desc": "Crea post social e volantini professionali per il tuo business.",
    "smart.hospitality.title": "Hospitality Creator",
    "smart.hospitality.desc": "Materiali e strumenti smart per strutture ricettive e ospitalità.",
    "smart.notify": "Presto disponibili nuovi servizi smart.",
    "cv.subtitle": "Crea un curriculum professionale su misura, scaricalo in PDF e scegli tra più modelli grafici professionali.",
    "cv.language": "Lingua del CV",
    "cv.fromScratch": "Crea da zero",
    "cv.improve": "Migliora CV esistente",
    "cv.tailor": "Adatta all'annuncio",
    "cv.scratchDesc": "Inserisci i tuoi dati e crea un CV professionale da zero.",
    "cv.improveDesc": "Carica o incolla il tuo CV attuale: lo riscriviamo rendendolo più chiaro, incisivo e professionale.",
    "cv.tailorDesc": "Carica il tuo CV e incolla un annuncio di lavoro: adattiamo il CV per massimizzare la coerenza con la posizione.",
    "cv.photo": "Foto profilo",
    "cv.addPhoto": "Aggiungi foto",
    "cv.changePhoto": "Cambia foto",
    "cv.optional": "(opzionale)",
    "cv.name": "Nome completo",
    "cv.role": "Ruolo / Titolo",
    "cv.phone": "Telefono",
    "cv.summary": "Profilo / Sommario",
    "cv.experience": "Esperienza",
    "cv.company": "Azienda",
    "cv.period": "Periodo",
    "cv.descr": "Descrizione",
    "cv.addExp": "Aggiungi esperienza",
    "cv.education": "Istruzione",
    "cv.degree": "Titolo di studio",
    "cv.institution": "Istituto",
    "cv.addEdu": "Aggiungi istruzione",
    "cv.skills": "Competenze",
    "cv.languages": "Lingue",
    "cv.jobOptional": "Annuncio di lavoro (opzionale)",
    "cv.jobPlaceholder": "Incolla qui il testo dell'annuncio di lavoro...",
    "cv.uploadOld": "Carica il tuo vecchio CV",
    "cv.chooseFile": "Scegli file",
    "cv.image": "Immagine",
    "cv.cvText": "Testo del CV",
    "cv.cvTextPlaceholder": "Il testo estratto dal file apparira' qui (puoi modificarlo)...",
    "cv.jobAd": "Annuncio di lavoro",
    "cv.generate": "Genera il tuo CV",
    "cv.generateShort": "Genera CV",
    "cv.working": "Stiamo creando il tuo CV...",
    "cv.preview": "Anteprima CV",
    "cv.history": "I miei CV",
    "cv.noHistory": "Nessun CV generato finora.",
    "cv.parsed": "File letto correttamente",
    "cv.generated": "CV generato!",
    "cv.template": "Modello",
    "cv.tplClassic": "Classico",
    "cv.tplModern": "Moderno",
    "cv.tplMinimal": "Minimal",
    "cv.lockedTitle": "Sblocca CV Smart Premium",
    "cv.lockedDesc": "Crea un curriculum professionale su misura, scaricalo in PDF e scegli tra più modelli grafici professionali.",
    "cv.oneTime": "una tantum",
    "cv.unlockNow": "Sblocca ora",
    "cv.stripeTest": "Pagamento sicuro tramite Stripe (modalità test).",
    "cv.unlocked": "Servizio sbloccato! Ora puoi generare i tuoi CV.",
    "cv.payCancelled": "Pagamento annullato.",
    "cv.confirmDelete": "Eliminare definitivamente questo CV?",
    "cv.deleted": "CV eliminato",
    "cv.adminMode": "Modalità Admin — hai accesso gratuito a CV Smart Premium",
    "cv.previewAsCustomer": "Anteprima come cliente",
    "cv.previewCustomerOn": "Anteprima cliente ATTIVA — vedi paywall e watermark come un utente non Premium",
    "cv.previewCustomerOff": "Modalità Admin — accesso gratuito. Attiva l'anteprima cliente per testare il paywall",
    "cv.previewingCustomer": "Stai vedendo la vista cliente",
    "cv.previewNote": "Anteprima cliente attiva: questa è la schermata che vede un utente non Premium.",
    "cv.chooseTitle": "Scegli il tuo modello CV",
    "cv.chooseSubtitle": "Anteprime reali dei modelli: scegli quello più adatto al tuo settore. Creeremo il tuo CV con il modello selezionato.",
    "cv.idealFor": "Ideale per",
    "cv.selectTemplate": "Seleziona modello",
    "cv.selected": "Selezionato",
    "cv.selectedTemplate": "Modello selezionato",
    "cv.changeTemplate": "Cambia modello",
    "cv.certifications": "Certificazioni",
    "cv.updated": "CV aggiornato e rigenerato!",
    "cv.updateRegenerate": "Aggiorna e rigenera",
    "cv.editingMode": "Stai modificando un CV esistente — aggiorna i campi e rigenera il documento.",
    "cv.exitEdit": "Esci dalla modifica",
    "cv.notFound": "CV non trovato",
    "cv.edit": "Modifica",
    "cv.rename": "Rinomina",
    "cv.deleteAction": "Elimina",
    "cv.paidBadge": "Sbloccato",
    "cv.watermarkBadge": "Anteprima con filigrana",
    "cv.unlockCta": "Sblocca il mio CV",
    "cv.unlockMyCv": "Sblocca il mio CV",
    "cv.paidSuccess": "Pagamento riuscito! Il tuo CV è sbloccato.",
    "cv.perCv": "per 1 CV",
    "cv.paywallTitle": "Il tuo curriculum è pronto",
    "cv.paywallLead": "Sblocca il download del file finale senza filigrana.",
    "cv.paywallInclude": "Ogni acquisto include la creazione di 1 curriculum professionale personalizzato.",
    "cv.paywallEditNote": "Puoi aggiornare e rigenerare il tuo CV in qualsiasi momento dall'area personale, mantenendo il modello scelto.",
    "cv.paywallItem1": "1 curriculum professionale personalizzato",
    "cv.paywallItem2": "PDF HD pronto per la candidatura",
    "cv.paywallItem3": "PDF senza filigrana, pronto all'invio",
    "cv.paywallItem4": "Scelta tra 6 modelli grafici professionali",
    // products
    "products.title": "Prodotti Digitali",
    "products.subtitle": "Strumenti e prodotti digitali scaricabili.",
    "products.empty": "Nessun prodotto trovato.",
    // product detail
    "detail.description": "Descrizione",
    "detail.category": "Categoria",
    "detail.demoNotice": "Prodotto dimostrativo: il file scaricabile contiene contenuti di esempio.",
    "detail.back": "Torna ai prodotti",
    // cart
    "cart.title": "Il tuo carrello",
    "cart.empty": "Il carrello è vuoto.",
    "cart.emptyCta": "Vai ai prodotti",
    "cart.total": "Totale",
    "cart.checkout": "Procedi al pagamento",
    "cart.remove": "Rimuovi",
    "cart.qty": "Q.tà",
    "cart.loginRequired": "Accedi per completare l'acquisto.",
    // auth
    "auth.loginTitle": "Accedi al tuo account",
    "auth.registerTitle": "Crea un account",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.name": "Nome completo",
    "auth.loginBtn": "Accedi",
    "auth.registerBtn": "Registrati",
    "auth.acceptTermsA": "Accetto i",
    "auth.acceptTermsB": "relativi all'account.",
    "auth.termsRequired": "Per registrarti devi accettare i Termini e condizioni.",
    "auth.privacyNoticeA": "Ho preso visione della",
    "auth.privacyNoticeB": ".",
    "auth.google": "Continua con Google",
    "auth.or": "oppure",
    "auth.noAccount": "Non hai un account?",
    "auth.hasAccount": "Hai già un account?",
    "auth.goRegister": "Registrati",
    "auth.goLogin": "Accedi",
    // account
    "account.title": "Area personale",
    "account.welcome": "Bentornato",
    "account.orders": "I miei acquisti",
    "account.noOrders": "Non hai ancora effettuato acquisti.",
    "account.myCvs": "I miei CV",
    "account.noCvs": "Non hai ancora generato nessun CV.",
    "account.downloads": "Download",
    "account.order": "Ordine",
    // about
    "about.title": "Chi siamo",
    "about.p1": "LearnSphereHub è una piattaforma e-commerce dedicata a prodotti digitali scaricabili e servizi smart personalizzati.",
    "about.p2": "La nostra missione è trasformare esigenze concrete in soluzioni pratiche, attraverso strumenti digitali di qualità e servizi professionali in continua evoluzione.",
    "about.p3": "Il catalogo comprende risorse per Career, Business & Social, Hospitality e OSS, oltre ai Servizi Smart.",
    "about.missionTitle": "La nostra missione",
    "about.mission": "Dal bisogno al risultato pronto.",
    // faq
    "faq.title": "Domande frequenti",
    "faq.q1": "I prodotti sono scaricabili?",
    "faq.a1": "Sì. Dopo l'acquisto trovi i file digitali nella tua area personale, pronti da scaricare.",
    "faq.q2": "Posso acquistare i prodotti?",
    "faq.a2": "I prodotti indicati come disponibili possono essere acquistati direttamente sul sito. Ogni scheda specifica contenuto, formato e modalità di utilizzo.",
    "faq.q3": "Come funzionano i pagamenti?",
    "faq.a3": "I pagamenti vengono elaborati in modo sicuro tramite Stripe. LearnSphereHub non conserva i dati delle carte di pagamento.",
    "faq.q4": "Cosa sono i Servizi Smart?",
    "faq.a4": "CV Smart è già disponibile. Gli altri Servizi Smart saranno pubblicati progressivamente.",
    "faq.q5": "OSS è il focus del sito?",
    "faq.a5": "No. OSS è soltanto una delle categorie del negozio.",
    // contact
    "contact.title": "Contatti",
    "contact.subtitle": "Hai una domanda? Scrivici, ti risponderemo al più presto.",
    "contact.name": "Nome",
    "contact.firstName": "Nome",
    "contact.lastName": "Cognome",
    "contact.subject": "Oggetto",
    "contact.email": "Email",
    "contact.message": "Messaggio",
    "contact.errRequired": "Campo obbligatorio",
    "contact.errName": "Da 2 a 60 caratteri",
    "contact.errSubject": "Da 3 a 120 caratteri",
    "contact.errMessage": "Da 10 a 5.000 caratteri",
    "contact.errPrivacy": "Devi accettare la Privacy Policy",
    "contact.privacyConsent": "Ho letto e accetto la",
    "contact.asideTitle": "Aiutaci a risponderti al meglio",
    "contact.asideBody": "Per ricevere una risposta precisa e più rapida, descrivi la tua richiesta in modo chiaro e completo.\nSe riguarda un prodotto o un servizio, indica il nome esatto. Se hai già effettuato un acquisto, aggiungi il numero dell'ordine. In caso di problema tecnico, specifica cosa stavi facendo, il dispositivo utilizzato e l'eventuale messaggio di errore.\nPiù informazioni utili ci fornisci, più facilmente potremo aiutarti senza doverti chiedere ulteriori dettagli.\nPer la tua sicurezza, non inserire password, dati completi di pagamento o altre informazioni sensibili.",
    "contact.errEmail": "Inserisci un indirizzo email valido",
    "contact.errSubjectInvalid": "L'oggetto non può contenere ritorni a capo",
    "contact.send": "Invia messaggio",
    "contact.success": "Messaggio inviato correttamente!",
    // payment
    "pay.successTitle": "Pagamento completato!",
    "pay.successSub": "Grazie per il tuo acquisto. Trovi i tuoi prodotti nell'area personale.",
    "pay.consentTitle": "Consensi registrati",
    "pay.consentTerms": "Termini e condizioni accettati; presa visione di Privacy Policy e Recesso e rimborsi.",
    "pay.consentVersion": "Versione testi legali",
    "pay.consentUnlocked": "Sblocco/consegna",
    "pay.verifying": "Verifica del pagamento in corso...",
    "pay.goAccount": "Vai all'area personale",
    "pay.cancelTitle": "Pagamento annullato",
    "pay.cancelSub": "Il pagamento è stato annullato. Il tuo carrello è ancora disponibile.",
    "pay.backCart": "Torna al carrello",
    // footer
    "footer.tagline": "Dal bisogno al risultato pronto.",
    "footer.shop": "Esplora",
    "footer.company": "LearnSphereHub",
    "footer.legal": "Legale",
    "footer.about": "Azienda",
    "footer.supportEmail": "Email assistenza",
    "footer.rights": "Tutti i diritti riservati.",
    "legal.privacy": "Privacy Policy",
    "legal.cookie": "Cookie Policy",
    "legal.terms": "Termini e condizioni",
    "legal.refund": "Recesso e rimborsi",
    "consent.termsA": "Accetto i",
    "consent.termsB": "e dichiaro di aver letto la",
    "consent.and": "e",
    "consent.immediateDownload": "Chiedo la fornitura immediata del contenuto digitale e riconosco che il diritto di recesso si perde nel momento in cui la fornitura ha inizio.",
    "consent.immediateService": "Chiedo l'avvio immediato del servizio e riconosco che il diritto di recesso si perde una volta completata l'esecuzione del servizio.",
    "consent.required": "Per procedere devi accettare i Termini e fornire i consensi richiesti.",
    "contact.sendNoticeA": "Inviando il messaggio dichiari di aver letto la",
    "contact.sendNoticeB": ". I dati saranno utilizzati esclusivamente per rispondere alla tua richiesta.",
    // admin
    "admin.title": "Pannello Amministratore",
    "admin.products": "Prodotti",
    "admin.categories": "Categorie",
    "admin.orders": "Ordini",
    "admin.messages": "Messaggi",
    "admin.pricing": "Prezzi",
    "admin.pricingTitle": "Prezzi CV Smart Premium",
    "admin.pricingDesc": "Configura il prezzo per singolo CV e la valuta. Le modifiche si applicano subito al paywall di download e al checkout Stripe.",
    "admin.cvPremiumPrice": "Prezzo per CV (download)",
    "admin.currency": "Valuta",
    "admin.pricingNote": "Il prezzo è gestito lato server: il cliente non può modificarlo. Solo gli admin possono cambiarlo qui.",
    "admin.aiCosts": "Costi AI",
    "admin.aiCostsTitle": "Costi AI — CV Smart Premium",
    "admin.aiCostsDesc": "Stima di token e costo AI per ogni CV generato. I valori sono calcolati con tiktoken sui prompt reali e sull'output del modello.",
    "admin.aiCvGenerated": "CV generati",
    "admin.aiTotalCost": "Costo AI totale",
    "admin.aiAvgPerCv": "Costo medio per CV",
    "admin.aiAvgTokens": "Token medi per CV",
    "admin.aiByMode": "Per modalità",
    "admin.aiOcr": "OCR immagini",
    "admin.aiRecent": "Generazioni recenti",
    "admin.aiRatesNote": "Tariffe stimate (modificabili via env)",
    "admin.aiNoData": "Nessuna generazione registrata finora.",
    "admin.aiMode": "Modalità",
    "admin.aiTokens": "Token (in / out)",
    "admin.aiCost": "Costo",
    "admin.aiWhen": "Quando",
    "admin.modeScratch": "Da zero",
    "admin.modeImprove": "Migliora",
    "admin.modeTailor": "Adatta",
    "admin.aiBudget": "Budget mensile AI",
    "admin.aiBudgetHint": "Imposta una soglia di spesa AI mensile: riceverai un avviso qui quando viene superata.",
    "admin.aiBudgetSet": "Soglia mensile (€)",
    "admin.aiBudgetMonth": "Spesa AI di questo mese",
    "admin.aiBudgetExceeded": "Budget AI mensile superato!",
    "admin.aiBudgetNear": "Stai per superare il budget AI mensile.",
    "admin.aiBudgetOk": "Sei entro il budget AI mensile.",
    "admin.aiBudgetNone": "Nessun budget impostato: imposta una soglia per ricevere avvisi.",
    "admin.aiBudgetSaved": "Budget aggiornato",
    "admin.aiBudgetOf": "su",
    "admin.aiMargin": "Margine netto per CV",
    "admin.aiMarginNote": "Guadagno stimato per ogni CV venduto, al netto del costo AI medio e della commissione Stripe.",
    "admin.aiMarginPrice": "Prezzo di vendita",
    "admin.aiMarginAi": "Costo AI medio",
    "admin.aiMarginStripe": "Commissione Stripe",
    "admin.aiMarginNet": "Margine netto",
    "admin.newProduct": "Nuovo prodotto",
    "admin.editProduct": "Modifica prodotto",
    "admin.save": "Salva",
    "admin.cancel": "Annulla",
    "admin.edit": "Modifica",
    "admin.delete": "Elimina",
    "admin.uploadImage": "Carica immagine",
    "admin.uploadFile": "Carica file scaricabile",
    "admin.price": "Prezzo (€)",
    "admin.titleIt": "Titolo (IT)",
    "admin.titleEn": "Titolo (EN)",
    "admin.descIt": "Descrizione (IT)",
    "admin.descEn": "Descrizione (EN)",
    "admin.category": "Categoria",
    "admin.imageUrl": "URL immagine (opzionale)",
    "admin.isDemo": "Prodotto DEMO",
    "admin.newCategory": "Nuova categoria",
    "admin.slug": "Slug",
    "admin.nameIt": "Nome (IT)",
    "admin.nameEn": "Nome (EN)",
    "admin.add": "Aggiungi",
    "admin.saved": "Salvato con successo",
    "admin.deleted": "Eliminato",
  },
  en: {
    "nav.home": "Home",
    "nav.products": "Digital Products",
    "nav.smart": "Smart Services",
    "nav.categories": "Categories",
    "nav.career": "Career",
    "nav.business": "Business & Social",
    "nav.hospitality": "Hospitality",
    "nav.oss": "OSS",
    "nav.about": "About",
    "nav.faq": "FAQ",
    "nav.contact": "Contact",
    "nav.cart": "Cart",
    "nav.account": "My account",
    "nav.login": "Sign in",
    "nav.register": "Sign up",
    "nav.logout": "Log out",
    "nav.admin": "Admin",
    "common.demo": "DEMO",
    "common.comingSoon": "Coming soon",
    "common.availableNow": "Available now",
    "common.tryNow": "Try it now",
    "common.addToCart": "Add to cart",
    "common.buyNow": "Buy now",
    "common.viewDetails": "View details",
    "common.from": "from",
    "common.explore": "Explore",
    "common.loading": "Loading...",
    "common.all": "All",
    "common.search": "Search products...",
    "common.free": "Free",
    "common.download": "Download",
    "common.discover": "Discover products",
    "common.discoverSmart": "Discover Smart Services",
    "hero.badge": "Digital tools & smart services",
    "hero.title": "Digital tools and smart services.",
    "hero.titleAccent": "From need to ready result.",
    "hero.subtitle": "LearnSphereHub is the marketplace for downloadable digital products and, soon, personalized smart services. Find the right tool and get results instantly.",
    "hero.cta1": "Explore products",
    "hero.cta2": "Smart Services",
    "home.categoriesTitle": "Explore by category",
    "home.categoriesSub": "Products organized by field. OSS is one of the store categories, not the whole site.",
    "home.featuredTitle": "Featured products",
    "home.featuredSub": "A selection of our digital products.",
    "home.howTitle": "How it works",
    "home.how1Title": "Choose the product",
    "home.how1": "Browse the digital product catalog by category.",
    "home.how2Title": "Buy securely",
    "home.how2": "Fast checkout with Stripe payments.",
    "home.how3Title": "Download instantly",
    "home.how3": "Find your files in your account, ready to use.",
    "home.smartTitle": "Smart Services",
    "home.smartSub": "Generate personalized results directly on LearnSphereHub.",
    "smart.title": "Smart Services",
    "smart.badge": "Tailored services",
    "smart.subtitle": "Personalized services that turn your need into a ready result.",
    "smart.cv.title": "CV Smart",
    "smart.cv.desc": "Generate a professional, tailored resume in minutes.",
    "smart.social.title": "Social & Flyer Creator",
    "smart.social.desc": "Create professional social posts and flyers for your business.",
    "smart.hospitality.title": "Hospitality Creator",
    "smart.hospitality.desc": "Smart materials and tools for hospitality businesses.",
    "smart.notify": "New smart services coming soon.",
    "cv.subtitle": "Create a tailored professional CV, download it as a PDF and choose from several professional templates.",
    "cv.language": "CV language",
    "cv.fromScratch": "Create from scratch",
    "cv.improve": "Improve existing CV",
    "cv.tailor": "Adapt to job ad",
    "cv.scratchDesc": "Enter your details and create a professional CV from scratch.",
    "cv.improveDesc": "Upload or paste your current CV: we rewrite it to be clearer, sharper and more professional.",
    "cv.tailorDesc": "Upload your CV and paste a job posting: we adapt the CV to maximise fit with the role.",
    "cv.photo": "Profile photo",
    "cv.addPhoto": "Add photo",
    "cv.changePhoto": "Change photo",
    "cv.optional": "(optional)",
    "cv.name": "Full name",
    "cv.role": "Role / Title",
    "cv.phone": "Phone",
    "cv.summary": "Profile / Summary",
    "cv.experience": "Experience",
    "cv.company": "Company",
    "cv.period": "Period",
    "cv.descr": "Description",
    "cv.addExp": "Add experience",
    "cv.education": "Education",
    "cv.degree": "Degree",
    "cv.institution": "Institution",
    "cv.addEdu": "Add education",
    "cv.skills": "Skills",
    "cv.languages": "Languages",
    "cv.jobOptional": "Job posting (optional)",
    "cv.jobPlaceholder": "Paste the job posting text here...",
    "cv.uploadOld": "Upload your old CV",
    "cv.chooseFile": "Choose file",
    "cv.image": "Image",
    "cv.cvText": "CV text",
    "cv.cvTextPlaceholder": "The text extracted from the file will appear here (you can edit it)...",
    "cv.jobAd": "Job posting",
    "cv.generate": "Generate your CV",
    "cv.generateShort": "Generate CV",
    "cv.working": "We're creating your CV...",
    "cv.preview": "CV preview",
    "cv.history": "My CVs",
    "cv.noHistory": "No CV generated yet.",
    "cv.parsed": "File read successfully",
    "cv.generated": "CV generated!",
    "cv.template": "Template",
    "cv.tplClassic": "Classic",
    "cv.tplModern": "Modern",
    "cv.tplMinimal": "Minimal",
    "cv.lockedTitle": "Unlock CV Smart Premium",
    "cv.lockedDesc": "Create a tailored professional CV, download it as a PDF and choose from several professional templates.",
    "cv.oneTime": "one-time",
    "cv.unlockNow": "Unlock now",
    "cv.stripeTest": "Secure payment via Stripe (test mode).",
    "cv.unlocked": "Service unlocked! You can now generate your CVs.",
    "cv.payCancelled": "Payment cancelled.",
    "cv.confirmDelete": "Permanently delete this CV?",
    "cv.deleted": "CV deleted",
    "cv.adminMode": "Admin mode — you have free access to CV Smart Premium",
    "cv.previewAsCustomer": "Preview as customer",
    "cv.previewCustomerOn": "Customer preview ACTIVE — you see the paywall and watermark like a non-Premium user",
    "cv.previewCustomerOff": "Admin mode — free access. Turn on customer preview to test the paywall",
    "cv.previewingCustomer": "Viewing the customer view",
    "cv.previewNote": "Customer preview active: this is the screen a non-Premium user sees.",
    "cv.chooseTitle": "Choose your CV template",
    "cv.chooseSubtitle": "Real previews of every template: pick the one that fits your field. We'll build your CV with the selected template.",
    "cv.idealFor": "Ideal for",
    "cv.selectTemplate": "Select template",
    "cv.selected": "Selected",
    "cv.selectedTemplate": "Selected template",
    "cv.changeTemplate": "Change template",
    "cv.certifications": "Certifications",
    "cv.updated": "CV updated and regenerated!",
    "cv.updateRegenerate": "Update & regenerate",
    "cv.editingMode": "You are editing an existing CV — update the fields and regenerate the document.",
    "cv.exitEdit": "Exit editing",
    "cv.notFound": "CV not found",
    "cv.edit": "Edit",
    "cv.rename": "Rename",
    "cv.deleteAction": "Delete",
    "cv.paidBadge": "Unlocked",
    "cv.watermarkBadge": "Watermarked preview",
    "cv.unlockCta": "Unlock my CV",
    "cv.unlockMyCv": "Unlock my CV",
    "cv.paidSuccess": "Payment successful! Your CV is unlocked.",
    "cv.perCv": "for 1 CV",
    "cv.paywallTitle": "Your CV is ready",
    "cv.paywallLead": "Unlock the download of the final file without watermark.",
    "cv.paywallInclude": "Each purchase includes the creation of 1 personalised professional resume.",
    "cv.paywallEditNote": "You can update and regenerate your CV anytime from your account area, keeping your chosen template.",
    "cv.paywallItem1": "1 personalised professional CV",
    "cv.paywallItem2": "HD PDF ready for applications",
    "cv.paywallItem3": "Watermark-free PDF, ready to send",
    "cv.paywallItem4": "Choice of 6 professional templates",
    "products.title": "Digital Products",
    "products.subtitle": "Downloadable digital tools and products.",
    "products.empty": "No products found.",
    "detail.description": "Description",
    "detail.category": "Category",
    "detail.demoNotice": "Demo product: the downloadable file contains sample content.",
    "detail.back": "Back to products",
    "cart.title": "Your cart",
    "cart.empty": "Your cart is empty.",
    "cart.emptyCta": "Go to products",
    "cart.total": "Total",
    "cart.checkout": "Proceed to payment",
    "cart.remove": "Remove",
    "cart.qty": "Qty",
    "cart.loginRequired": "Sign in to complete your purchase.",
    "auth.loginTitle": "Sign in to your account",
    "auth.registerTitle": "Create an account",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.name": "Full name",
    "auth.loginBtn": "Sign in",
    "auth.registerBtn": "Sign up",
    "auth.acceptTermsA": "I accept the",
    "auth.acceptTermsB": "for the account.",
    "auth.termsRequired": "To sign up you must accept the Terms & Conditions.",
    "auth.privacyNoticeA": "I have read the",
    "auth.privacyNoticeB": ".",
    "auth.google": "Continue with Google",
    "auth.or": "or",
    "auth.noAccount": "Don't have an account?",
    "auth.hasAccount": "Already have an account?",
    "auth.goRegister": "Sign up",
    "auth.goLogin": "Sign in",
    "account.title": "My account",
    "account.welcome": "Welcome back",
    "account.orders": "My purchases",
    "account.noOrders": "You haven't made any purchases yet.",
    "account.myCvs": "My CVs",
    "account.noCvs": "You haven't generated any CV yet.",
    "account.downloads": "Downloads",
    "account.order": "Order",
    "about.title": "About us",
    "about.p1": "LearnSphereHub is an e-commerce platform dedicated to downloadable digital products and personalized smart services.",
    "about.p2": "Our mission is to turn real needs into practical solutions, through quality digital tools and ever-evolving professional services.",
    "about.p3": "The catalog includes resources for Career, Business & Social, Hospitality and OSS, plus the Smart Services.",
    "about.missionTitle": "Our mission",
    "about.mission": "From need to ready result.",
    "faq.title": "Frequently asked questions",
    "faq.q1": "Are products downloadable?",
    "faq.a1": "Yes. After purchase you'll find the digital files in your account, ready to download.",
    "faq.q2": "Can I buy the products?",
    "faq.a2": "Products marked as available can be purchased directly on the site. Each listing specifies content, format and how to use it.",
    "faq.q3": "How do payments work?",
    "faq.a3": "Payments are securely processed through Stripe. LearnSphereHub does not store payment card data.",
    "faq.q4": "What are Smart Services?",
    "faq.a4": "CV Smart is already available. The other Smart Services will be released progressively.",
    "faq.q5": "Is OSS the focus of the site?",
    "faq.a5": "No. OSS is just one of the store categories.",
    "contact.title": "Contact",
    "contact.subtitle": "Have a question? Write to us and we'll get back to you soon.",
    "contact.name": "Name",
    "contact.firstName": "First name",
    "contact.lastName": "Last name",
    "contact.subject": "Subject",
    "contact.email": "Email",
    "contact.message": "Message",
    "contact.errRequired": "Required field",
    "contact.errName": "Between 2 and 60 characters",
    "contact.errSubject": "Between 3 and 120 characters",
    "contact.errMessage": "Between 10 and 5,000 characters",
    "contact.errPrivacy": "You must accept the Privacy Policy",
    "contact.privacyConsent": "I have read and accept the",
    "contact.asideTitle": "Help us assist you better",
    "contact.asideBody": "To receive a more accurate and faster response, describe your request clearly and completely.\nIf it concerns a product or service, include its exact name. If you have already made a purchase, add your order number. For technical issues, explain what you were doing, the device you were using and any error message displayed.\nThe more useful information you provide, the easier it will be for us to assist you without requesting additional details.\nFor your security, do not include passwords, full payment details or other sensitive information.",
    "contact.errEmail": "Enter a valid email address",
    "contact.errSubjectInvalid": "The subject cannot contain line breaks",
    "contact.send": "Send message",
    "contact.success": "Message sent successfully!",
    "pay.successTitle": "Payment completed!",
    "pay.successSub": "Thank you for your purchase. You'll find your products in your account.",
    "pay.consentTitle": "Recorded consents",
    "pay.consentTerms": "Terms & Conditions accepted; Privacy Policy and Withdrawal & Refunds acknowledged.",
    "pay.consentVersion": "Legal texts version",
    "pay.consentUnlocked": "Unlock/delivery",
    "pay.verifying": "Verifying payment...",
    "pay.goAccount": "Go to my account",
    "pay.cancelTitle": "Payment cancelled",
    "pay.cancelSub": "The payment was cancelled. Your cart is still available.",
    "pay.backCart": "Back to cart",
    "footer.tagline": "From need to ready result.",
    "footer.shop": "Explore",
    "footer.company": "LearnSphereHub",
    "footer.legal": "Legal",
    "footer.about": "Company",
    "footer.supportEmail": "Support email",
    "footer.rights": "All rights reserved.",
    "legal.privacy": "Privacy Policy",
    "legal.cookie": "Cookie Policy",
    "legal.terms": "Terms & Conditions",
    "legal.refund": "Withdrawal & Refunds",
    "consent.termsA": "I accept the",
    "consent.termsB": "and confirm I have read the",
    "consent.and": "and",
    "consent.immediateDownload": "I request immediate supply of the digital content and acknowledge that the right of withdrawal is lost once supply begins.",
    "consent.immediateService": "I request immediate start of the service and acknowledge that the right of withdrawal is lost once the service has been fully performed.",
    "consent.required": "To proceed you must accept the Terms and provide the required consents.",
    "contact.sendNoticeA": "By sending the message you confirm you have read the",
    "contact.sendNoticeB": ". Your data will be used solely to reply to your request.",
    "admin.title": "Admin Panel",
    "admin.products": "Products",
    "admin.categories": "Categories",
    "admin.orders": "Orders",
    "admin.messages": "Messages",
    "admin.pricing": "Pricing",
    "admin.pricingTitle": "CV Smart Premium pricing",
    "admin.pricingDesc": "Configure the per-CV price and currency. Changes apply instantly to the download paywall and Stripe checkout.",
    "admin.cvPremiumPrice": "Price per CV (download)",
    "admin.currency": "Currency",
    "admin.pricingNote": "The price is managed server-side: customers cannot change it. Only admins can update it here.",
    "admin.aiCosts": "AI costs",
    "admin.aiCostsTitle": "AI costs — CV Smart Premium",
    "admin.aiCostsDesc": "Estimated tokens and AI cost for every generated CV. Values are computed with tiktoken on the real prompts and the model output.",
    "admin.aiCvGenerated": "CVs generated",
    "admin.aiTotalCost": "Total AI cost",
    "admin.aiAvgPerCv": "Average cost per CV",
    "admin.aiAvgTokens": "Average tokens per CV",
    "admin.aiByMode": "By mode",
    "admin.aiOcr": "Image OCR",
    "admin.aiRecent": "Recent generations",
    "admin.aiRatesNote": "Estimated rates (configurable via env)",
    "admin.aiNoData": "No generation recorded yet.",
    "admin.aiMode": "Mode",
    "admin.aiTokens": "Tokens (in / out)",
    "admin.aiCost": "Cost",
    "admin.aiWhen": "When",
    "admin.modeScratch": "From scratch",
    "admin.modeImprove": "Improve",
    "admin.modeTailor": "Tailor",
    "admin.aiBudget": "Monthly AI budget",
    "admin.aiBudgetHint": "Set a monthly AI spending threshold: you'll get an alert here when it's exceeded.",
    "admin.aiBudgetSet": "Monthly threshold (€)",
    "admin.aiBudgetMonth": "This month's AI spend",
    "admin.aiBudgetExceeded": "Monthly AI budget exceeded!",
    "admin.aiBudgetNear": "You're about to exceed the monthly AI budget.",
    "admin.aiBudgetOk": "You're within the monthly AI budget.",
    "admin.aiBudgetNone": "No budget set: set a threshold to receive alerts.",
    "admin.aiBudgetSaved": "Budget updated",
    "admin.aiBudgetOf": "of",
    "admin.aiMargin": "Net margin per CV",
    "admin.aiMarginNote": "Estimated profit for each CV sold, after the average AI cost and the Stripe fee.",
    "admin.aiMarginPrice": "Sale price",
    "admin.aiMarginAi": "Avg AI cost",
    "admin.aiMarginStripe": "Stripe fee",
    "admin.aiMarginNet": "Net margin",
    "admin.newProduct": "New product",
    "admin.editProduct": "Edit product",
    "admin.save": "Save",
    "admin.cancel": "Cancel",
    "admin.edit": "Edit",
    "admin.delete": "Delete",
    "admin.uploadImage": "Upload image",
    "admin.uploadFile": "Upload downloadable file",
    "admin.price": "Price (€)",
    "admin.titleIt": "Title (IT)",
    "admin.titleEn": "Title (EN)",
    "admin.descIt": "Description (IT)",
    "admin.descEn": "Description (EN)",
    "admin.category": "Category",
    "admin.imageUrl": "Image URL (optional)",
    "admin.isDemo": "DEMO product",
    "admin.newCategory": "New category",
    "admin.slug": "Slug",
    "admin.nameIt": "Name (IT)",
    "admin.nameEn": "Name (EN)",
    "admin.add": "Add",
    "admin.saved": "Saved successfully",
    "admin.deleted": "Deleted",
  },
};
